import { render, staticRenderFns } from "./LogSolicitacaoAutorizacao.vue?vue&type=template&id=fb12eed0&"
import script from "./LogSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
export * from "./LogSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports